export default {
    computed: {
      switches() { return Object.keys(((((this.$store.getters.settings.settings || {}).app || {}).show || {}).customer || {})); },
    },
    methods: {
      show(blockName) { return this.switches.length===0 || this.switches.includes(blockName) },
    }
}